export const SCHEDULED = 'scheduled';
export const LIVE = 'live';
export const PENDING = 'pending';
export const TICK = 'tick';
